import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { MijnTokensBrowserAnalyticsService } from '../analytics/analytics.service';
import { MijnTokensBrowserNavigation } from '../mijn-tokens-browser.navigation';
import { MijnTokensBrowserService } from '../mijn-tokens-browser.service';

/**
 * @module VerifyPincodeWrapperModule
 * @ngdoc component
 * @name VerifyPincodeWrapperComponent
 */
@Component({
    selector: 'tokens-browser-verify-pincode-wrapper',
    templateUrl: 'verify-pincode.wrapper.component.html',
    standalone: false
})
export class VerifyPincodeWrapperComponent implements OnInit {
    public constructor(
        private readonly activatedRoute: ActivatedRoute,
        private readonly analyticsService: MijnTokensBrowserAnalyticsService,
        private readonly navigation: MijnTokensBrowserNavigation,
        private readonly mijnTokensBrowserService: MijnTokensBrowserService
    ) {}

    public ngOnInit(): void {
        this.navigation.init(this.activatedRoute.parent);
        this.sendFormStepAnalytics();
    }

    public getPincode(): string {
        return this.mijnTokensBrowserService.getPincode();
    }

    public onVerifyPincode(): void {
        this.navigation.toName();
    }

    public onBack(): void {
        this.navigation.toPincode();
    }

    private sendFormStepAnalytics(): void {
        this.analyticsService.pushFormStepAnalytics(MijnTokensBrowserNavigation.VERIFY_PINCODE, 2, 'start');
    }
}
